module.exports = __webpack_public_path__ + "img/welfare-ico-1.108116eb.png";